import React from 'react';
import {Link} from 'react-router';

import Footer from './Footer';

import Logo from '../../images/logo.png';

import MaxProfile from '../../images/team-max.jpg';
import DanieleProfile from '../../images/team-daniele.jpg';
import MarceloProfile from '../../images/team-marcelo.jpg';

let profiles = [
  {
    name: 'Max Rhodes',
    title: 'Chief Executive Officer & Founder',
    description: "Prior to starting Indigo Fair, Max was the first product manager for " +
    "several key initiatives at Square, including Square Capital ($1Bn+ deployed) and Square " +
    "Cash (Square's only Top 50-ranked app in the iOS App Store). " +
    "He first came up with the idea for Indigo Fair while introducing the Blunt Umbrella to " +
    "the United States, helping to place Blunt into over 100 local retailers.",
    photo: MaxProfile,
    layout: 'photo-right'
  },
  {
    name: 'Daniele Perito',
    title: 'Chief Information Officer & Founder',
    description: "Prior to starting Indigo Fair, he led Risk and Security for Square Cash, " +
    "where he designed and implemented the anti-abuse and anti-fraud systems that have made " +
    "Cash possible. He holds his PhD in Computer Science with a focus on security and machine learning.",
    photo: DanieleProfile,
    layout: 'photo-left'
  },
  {
    name: 'Marcelo Cortes',
    title: 'Chief Technology Officer & Founder',
    description: "He has over 18 years of software engineering experience. Prior to starting Indigo " +
    "Fair, Marcelo was an engineering lead for Square Cash since the product started early in 2013. " +
    "Before that, he was an engineering lead on Google+ for Android and launched the first mobile " +
    "version of Google Hangouts.",
    photo: MarceloProfile,
    layout: 'photo-right'
  }
];

export default class Team extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    let profileContents = profiles.map((profile, idx) => {
      let key = 'profile-' + idx;
      let imageWrapper = <div className="image-wrapper"><img role="presentation"
                                                             src={profile.photo}/></div>;
      return (
        <div key={key} className="entry">
          {profile.layout === 'photo-left' ? imageWrapper : null}
          <div className="profile-contents">
            <h2>{profile.name}</h2>
            <h3>{profile.title}</h3>
            <p>{profile.description}</p>
          </div>
          {profile.layout === 'photo-right' ? imageWrapper : null}
        </div>
      )
    });

    return (
      <div className="team">
        <div className="header-wrapper">
          <div className="content">
            <div className="logo-wrapper">
              <Link to="/">
                <img src={Logo} role="presentation"/>
              </Link>
            </div>
          </div>
        </div>
        <div className="preamble">
          <div>Our team combines over 15 years of experience building software products for small
            business customers.
          </div>
        </div>
        <div className="profiles">
          {profileContents}
        </div>
        <Footer />
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/views/Home/Team.js
 **/